/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

// @mui material components
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import CampaignProductFree from './CamprignProductFree';

const initAttr = {
  id: '',
  product_id: '',
  campaign_id: '',
  unit_id: '',
  quantity: '',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

function CampaignFree() {
  const mod = 'campaign_free';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalEdit, setModalEdit] = useState(false);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.id', label: 'No.', align: 'center' },
    { id: 'tb.image_id', label: t(`attr.image`), align: 'center' },
    { id: 'pd.barcode', label: 'Barcode', align: 'left' },
    { id: 'pd.name', label: 'สินค้า', align: 'left' },
    { id: 'tb.unit_id', label: 'หน่วย', align: 'left' },
    { id: 'delete', label: '', align: 'center', sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      ref_id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = (item) => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);

    FetchData('GET', `/${mod}/${item.id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setModalEdit(true);

        setLoading(false);
      }
    });
  };

  const add = (item) => {
    setLoading(true);

    FetchData('PUT', `/${mod}`, app.token, {
      campaign_id: id,
      barcode_id: item.barcode_id,
      quantity: item.quantity,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.quantity, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);
    setModalEdit(false);
    setConfirm(false);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      quantity: attr.quantity,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setModalEdit(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = (item) => {
    Swal.fire({
      title: t(`alert.confirm_delete_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.deleteconfirm`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('DELETE', `/${mod}/${item.id}`, app.token, {}).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            view(find);
            showNotify(t(`alert.deletecomplete`), 'success');
          } else {
            showNotify(t(`alert.deleteerror`), 'error');
          }
        });
      }
    });
  };

  const btnOpen = (item) => {
    return (
      <MDButton
        variant='text'
        color='info'
        size='small'
        sx={{ fontSize: '1rem', p: 0, m: 0, display: 'inline-block' }}
        onClick={() => open(item)}
      >
        {Func.numberDisplay(item.quantity)}
      </MDButton>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const btnDel = (item) => {
    return (
      <MDButton variant='text' color='error' size='small' iconOnly onClick={() => del(item)}>
        <Icon>delete</Icon>
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} lg={10}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, page: 1 });
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={7}>
                  <MDInput
                    name='searchform'
                    fullWidth
                    value={find.search}
                    onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                      ),
                      autoComplete: 'off',
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={3} lg={2} sx={{ textAlign: 'right' }}>
            <CampaignProductFree add={add} />
          </Grid>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0, minHeight: 300 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center' width={10}>
                        {row.no}
                      </TableCell>
                      <TableCell align='center' width={40}>
                        {Func.imageDisplay(row)}
                      </TableCell>
                      <TableCell align='left'>{row.barcode}</TableCell>
                      <TableCell align='left'>
                        <MDBox>{row.code}</MDBox>
                        <MDBox className='nowrap'>{row.name}</MDBox>
                      </TableCell>
                      <TableCell align='left' width={120}>
                        {row.unit_name}
                      </TableCell>
                      <TableCell align='center' width={10}>
                        {btnDel(row)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
              <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                {t(`element.show_record`, { num: find.perPage })}&nbsp;
                <Icon>keyboard_arrow_down</Icon>
              </MDButton>
              {renderShow}
              <Pagination
                count={pageTotal}
                variant='outlined'
                color='secondary'
                showFirstButton
                showLastButton
                page={pageNo}
                onChange={(e, p) => view({ ...find, page: p })}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDInput
            label='ปริมาณ'
            onFocus={(e) => e.target.select()}
            onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
            value={attr.quantity}
            variant='standard'
            type='number'
            fullWidth
            InputProps={{
              autoComplete: 'off',
              endAdornment: (
                <InputAdornment position='end'>
                  <span>{attr.unit_name}</span>
                </InputAdornment>
              ),
              inputProps: {
                className: 'text-right',
              },
            }}
          />
        </Grid>
      </Grid>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog open={modalEdit} maxWidth='xs' keepMounted aria-describedby='dialog-edit' fullWidth>
        <DialogTitle>
          <MDBox className='cut' sx={{ width: 380 }}>
            {attr.barcode} : {attr.name}
          </MDBox>
          <IconButton
            aria-label='close'
            onClick={() => setModalEdit(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='success' onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    view(find);
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderEdit()}
      {renderLoading()}
      {notify}
    </div>
  );
}

export default CampaignFree;
